// src/components/WebsiteUrlInput.js
import React from 'react';
import { Check, AlertCircle } from 'lucide-react';

const WebsiteUrlInput = ({ websiteUrl, onWebsiteChange, websiteVerified, onWebsiteVerify }) => {
  const handleInput = (e) => {
    let url = e.target.value;
    if (url && !url.startsWith('http://') && !url.startsWith('https://')) {
      url = 'https://' + url;
    }
    onWebsiteChange(url);
  };

  return (
    <>
      <div className="flex items-center gap-2">
        <input
          type="url"
          value={websiteUrl}
          onChange={handleInput}
          onBlur={onWebsiteVerify}
          placeholder="https://yourwebsite.com"
          className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
        />

        {websiteVerified === 'checking' && (
          <div className="flex items-center gap-2 text-sm text-gray-600 flex-shrink-0">
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-purple-600" />
            <span className="hidden sm:inline">Checking...</span>
          </div>
        )}
        {websiteVerified === 'verified' && (
          <div className="flex items-center gap-1 text-sm text-green-600 font-medium flex-shrink-0">
            <Check className="w-4 h-4" />
            <span className="hidden sm:inline">Verified</span>
          </div>
        )}
        {websiteVerified === 'failed' && (
          <div className="flex items-center gap-1 text-sm text-amber-600 flex-shrink-0">
            <AlertCircle className="w-4 h-4" />
            <span className="hidden sm:inline">Could not verify</span>
          </div>
        )}
      </div>
      <p className="text-xs text-gray-500 mt-2">Must start with https:// or http://</p>
    </>
  );
};

export default WebsiteUrlInput;
